import { Formik } from 'formik';
import pluralize from 'pluralize';
import React, { useRef } from 'react';
import * as Yup from 'yup';
import { FieldControl, Form } from '~/components';
import { BulkActionModal } from '~/components/bulk-action';
import FixedDropdown from '~/components/FixedDropdown';
import { useApi, useWorkspace } from '~/contexts';
import ResourceSelect from '../../components/ResourceSelect';
import AllocationSummary from './AllocationSummary';

export default function BulkReassign({ ids, onClose, onComplete }) {
  const { workspace } = useWorkspace();
  const api = useApi();
  const formRef = useRef();

  return (
    <BulkActionModal
      title="Bulk Reassign"
      onClose={onClose}
      onComplete={onComplete}
      onConfirm={() => formRef.current?.submitForm()}
      renderRow={AllocationSummary}>
      <Formik
        innerRef={formRef}
        initialValues={{ resource: null }}
        validateOnBlur={false}
        validateOnChange={false}
        validationSchema={Yup.object().shape({
          resource: Yup.object().label('Resource').nullable().required('Please select a resource.'),
        })}
        onSubmit={({ resource }) =>
          api.www
            .workspaces(workspace.id)
            .allocations()
            .bulkReassign(ids, {
              resourceTypeId: resource.resourceType,
              memberId: resource.resourceType === 'member' ? resource.id : null,
              resourcePlaceholderId: resource.resourceType === 'placeholder' ? resource.id : null,
            })
            .then((r) => r.data)
        }>
        {(formik) => (
          <Form>
            <p>
              Reassign {ids.length} {pluralize('allocation', ids.length)} to a different resource. Each allocation stays
              on its current project, role, dates, and hours.
            </p>

            <Form.Control>
              <FieldControl error={formik.submitCount > 0 && formik.errors.resource}>
                <ResourceSelect
                  placeholder="Member or Resource Placeholder"
                  component={FixedDropdown}
                  value={formik.values.resource}
                  onChange={(event) => formik.setFieldValue('resource', event.target.value)}
                />
              </FieldControl>
            </Form.Control>
          </Form>
        )}
      </Formik>
    </BulkActionModal>
  );
}
